import { render, staticRenderFns } from "./approve-employee-emolument.vue?vue&type=template&id=fa82d0c2"
import script from "./approve-employee-emolument.vue?vue&type=script&lang=js"
export * from "./approve-employee-emolument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports